import React from 'react'
import { Divider } from '@mui/material'
import { useTranslation } from 'i18n'
// @ts-expect-error SCSS modules are untyped here, as in the sibling Puck blocks
import * as styles from './OfferCard.module.scss'
import type { PromoItem } from './usePromoItems'

type OfferCardProps = PromoItem & {
  className?: string
  wide?: boolean
}

const OfferCard = ({
  id,
  imageUrl,
  expiryDate,
  title,
  copy,
  cta,
  ctaUrl,
  abbreviatedTerms,
  className,
  wide = false,
}: OfferCardProps) => {
  const { t } = useTranslation('promo')
  const handleCtaClick = () => {
    const dataLayer = (window as unknown as {
      dataLayer?: Array<Record<string, unknown>>
    })?.dataLayer
    dataLayer?.push({
      event: 'promo_offer_cta_click',
      promo_offer_id: id,
      promo_offer_headline: title,
    })
  }

  return (
    <div className={`${styles.card}${className ? ` ${className}` : ''}`}>
      {wide ? (
        <div className={styles.imageWrapper}>
          {imageUrl && (
            <img src={imageUrl} alt={title} className={styles.image} />
          )}
          {cta && (
            <a href={ctaUrl} className={styles.wideCta} onClick={handleCtaClick}>
              {cta}
            </a>
          )}
        </div>
      ) : (
        imageUrl && <img src={imageUrl} alt={title} className={styles.image} />
      )}
      {expiryDate && (
        <p className={styles.expiry}>{t('expires', { date: expiryDate })}</p>
      )}
      <Divider
        style={{
          borderColor: '#b7b7b7',
          marginBlock: 2,
          margin: wide ? '10px 15px 0px 15px' : '5px 15px 0px 15px',
        }}
      />
      {title && <h3 className={styles.title}>{title}</h3>}
      {copy && (
        <div
          className={wide ? styles.wideCopy : styles.copy}
          // copy is authored by admins in beaker2's rich-text editor, same as on
          // the site-scoped promo page this was ported from.
          dangerouslySetInnerHTML={{ __html: copy }}
        />
      )}
      {wide && cta && (
        <a
          href={ctaUrl}
          className={`${styles.cta} ${styles.mobileOnlyCta}`}
          onClick={handleCtaClick}
        >
          {cta}
        </a>
      )}
      {!wide && cta && (
        <a href={ctaUrl} className={styles.cta} onClick={handleCtaClick}>
          {cta}
        </a>
      )}
      {abbreviatedTerms && <p className={styles.terms}>{abbreviatedTerms}</p>}
      <div className={styles.spacer} />
    </div>
  )
}

export default OfferCard
